jQuery(document).ready(function(){
	$('#homepage_carousel .carousel-item:first').addClass('active');
	$('#homepage_carousel').carousel({
		interval: 6000,

	})
});

jQuery(document).ready(function($){
	$('#carousel').slick({
    	centerMode: true,
	    centerPadding: '20%',
	    slidesToShow: 2,
	    autoplay: true,
	    autoplaySpeed: 4000,
	    responsive: [
		    {
		      breakpoint: 1300,
		      settings: {
		        centerPadding: '20%',
		      	slidesToShow: 1,
		      }
		    },
		    {
		      breakpoint: 900,
		      settings: {
		        centerPadding: '15%',
		      	slidesToShow: 1,
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		        centerPadding: '10%',
		      	slidesToShow: 1,
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		      	centerMode: false,
		        centerPadding: '0',
		      	slidesToShow: 1,
		      }
		    }
		]
  	});
});
